// The public V2 acquisition destination. Pool credentials never belong here.
export const APP_ACQUISITION_URL = "https://app.sportsmet.com/get-started";
export const APP_SHARE_TITLE = "Join me on Sportsmet";
export const APP_SHARE_TEXT =
  "Join me on Sportsmet for sports pools, scores, and friends.";
export type typeShareResult = "shared" | "canceled" | "copied" | "failed";

export async function copyAppLink(
  copy: (text: string) => Promise<boolean>,
  url = APP_ACQUISITION_URL,
): Promise<typeShareResult> {
  try {
    return (await copy(url)) ? "copied" : "failed";
  } catch {
    return "failed";
  }
}

export async function shareApp(input: {
  share?:
    | ((payload: {
        title: string;
        text: string;
        url: string;
      }) => Promise<"shared" | "canceled">)
    | undefined;
  copy: (text: string) => Promise<boolean>;
  url?: string;
}): Promise<typeShareResult> {
  const url = input.url ?? APP_ACQUISITION_URL;
  if (!input.share) return copyAppLink(input.copy, url);
  try {
    return await input.share({
      title: APP_SHARE_TITLE,
      text: APP_SHARE_TEXT,
      url,
    });
  } catch (error) {
    if (error instanceof Error && error.name === "AbortError")
      return "canceled";
    return "failed";
  }
}

export function shareResultMessage(result: typeShareResult): string {
  if (result === "copied") return "Link copied.";
  if (result === "failed")
    return "Couldn't share the link. Try Copy link or select the link below.";
  return "";
}
